import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import {
  BackIcon,
  BorderDiv,
  Container,
  DetailView,
  SkillCircle,
} from "./styles";
import {
  BoldHeading,
  BoldLg,
  HorizontalAlign,
  HorizontalLeftAlign,
  RegLg,
} from "../../../../Components/CustomStyles";
import IconButton from "../../../../Components/IconButton";
import {
  deleteCourseRequest,
  getContentRequest,
  getCourseEnrollReqRequest,
  postCourseEnrollRequest,
} from "../../../../Redux/actions/home";
import ModalComponent from "../../../../Components/Modal";
import SmartImage from "../../../../Components/SmartImage";
import images from "../../../../Constant/images";

const CourseDetails = ({ handleView, course, heading, setHeading }) => {
  const dispatch = useDispatch();
  const { isInstructor } = useSelector((state) => state.auth);
  const { req_count } = useSelector((state) => state.home);
  let skills = [1, 2, 3, 4, 5];

  const [openPopup, setOpenPopup] = useState(false);
  const [courseDetails, setCourseDetails] = useState([]);

  const handleCourseMaterial = () => {
    handleView("courseMaterial", course);
    let arr = heading;
    arr.forEach((fe) => (fe.isSelected = fe.id === 0));
    setHeading(arr);
  };
  const handleCourseEdit = () => {
    handleView("new", course);
  };
  const handleRegisterCourse = () => {
    // console.log("handleRegisterCourse");
    let data = {
      course_id: course?.id,
    };
    dispatch(postCourseEnrollRequest(data));
    setTimeout(() => {
      handleBack();
    }, 1000);
  };
  const handleBack = () => handleView("list");
  const handleOpenPopup = () => setOpenPopup(true);
  const handleClosePopup = () => setOpenPopup(false);

  const deleteCourse = () => {
    setOpenPopup(false);
    let data = { id: course?.id };
    dispatch(deleteCourseRequest(data));
    setTimeout(() => {
      handleBack();
    }, 1000);
  };

  useEffect(() => {
    if (course?.title) {
      setCourseDetails([
        {
          id: 0,
          name: "title",
          title: "Title",
          value: course?.title,
        },
        {
          id: 1,
          name: "subject",
          title: "Subject",
          value: course?.subject,
        },
        {
          id: 2,
          name: "skill_level",
          title: "Skill Level",
          value: course?.skill_level,
        },
        {
          id: 3,
          name: "slug",
          title: "Slug",
          value: course?.slug,
        },
        {
          id: 9,
          name: "price",
          title: "Course Fee",
          value: course?.price,
        },
        {
          id: 4,
          name: "description",
          title: "Description",
          value: course?.description,
        },
        {
          id: 5,
          name: "prerequisite",
          title: "Prerequisites",
          value: course?.prerequisite,
        },
        {
          id: 5,
          name: "certificate",
          title: "certificate",
          value: course?.certificate,
        },
        {
          id: 6,
          name: "credit_hours",
          title: "Credit Hours",
          value: course?.credit_hours,
        },
        {
          id: 7,
          name: "start_date",
          title: "Start Date",
          value: dayjs(course?.start_date).format("MMM D, YYYY"),
        },
        {
          id: 8,
          name: "end_date",
          title: "End Date",
          value: dayjs(course?.end_date).format("MMM D, YYYY"),
        },
      ]);
    }
  }, [course]);

  useEffect(() => {
    if ((course?.type === "mine" || course?.type === "new") && isInstructor) {
      dispatch(getCourseEnrollReqRequest({ course_id: course?.id }));
    }
  }, []);

  return (
    <Container>
      <HorizontalLeftAlign style={{ marginTop: 10, marginBottom: 10 }}>
        <BackIcon onClick={handleBack}>
          <KeyboardBackspaceIcon style={{ marginBottom: -6 }} />
        </BackIcon>
        <BoldHeading style={{ textTransform: "capitalize" }}>
          {course?.title}
        </BoldHeading>
      </HorizontalLeftAlign>
      <div>
        <SmartImage
          src={course?.banner ? course?.banner : images.course}
          style={{ height: 150, width: "100%" }}
        />
      </div>
      <DetailView>
        {courseDetails.map((each) => (
          <div style={{ marginBottom: 20, width: "48%" }}>
            <BoldHeading style={{ textTransform: "capitalize" }}>
              {each?.title}
            </BoldHeading>

            {each?.name === "skill_level" ? (
              <HorizontalLeftAlign style={{ padding: 8 }}>
                {skills.map((e, i) => (
                  <SkillCircle
                    skill={course?.skill_level}
                    index={i}
                  ></SkillCircle>
                ))}
              </HorizontalLeftAlign>
            ) : (
              <BorderDiv title={each?.name}>
                <RegLg style={{ padding: 10 }}>
                  {each?.title === "Course Fee" && each.value === 0
                    ? "Free"
                    : each?.value ?? "N/A"}
                </RegLg>
              </BorderDiv>
            )}
          </div>
        ))}
      </DetailView>
      {isInstructor && course?.type !== "waiting" ? (
        <HorizontalLeftAlign
          style={{
            position: "absolute",
            bottom: 20,
            backgroundColor: "#fff",
            width: "70%",
          }}
        >
          {new Date().toISOString() < course?.end_date && (
            <IconButton
              text={"Edit"}
              onClick={handleCourseEdit}
              textStyle={{ fontWeight: "500" }}
              style={{ width: 100, borderRadius: 5, marginRight: 10 }}
            />
          )}
          <IconButton
            text={"Material"}
            onClick={handleCourseMaterial}
            textStyle={{ fontWeight: "500" }}
            style={{ width: 100, borderRadius: 5, marginRight: 10 }}
          />
          <IconButton
            text={`${req_count} New Request${req_count > 1 ? "s" : ""}`}
            onClick={() => handleView("courseRequests", course)}
            textStyle={{ fontWeight: "500" }}
            style={{ width: 180, borderRadius: 5, marginRight: 10 }}
          />
          <IconButton
            text={"Delete"}
            textStyle={{ fontWeight: "500" }}
            onClick={handleOpenPopup}
            style={{ width: 100, borderRadius: 5, backgroundColor: "#8B0000" }}
          />
        </HorizontalLeftAlign>
      ) : (
        <HorizontalLeftAlign
          style={{
            position: "absolute",
            bottom: 20,
            backgroundColor: "#fff",
            width: "90%",
          }}
        >
          {course?.type === "mine" ? (
            <IconButton
              text={"Material"}
              textStyle={{ fontWeight: "500" }}
              onClick={handleCourseMaterial}
              style={{ width: 100, borderRadius: 5, marginRight: 10 }}
            />
          ) : course?.type === "new" &&
            new Date().toISOString() < course?.end_date ? (
            <IconButton
              text={"Register Now"}
              textStyle={{ fontWeight: "500" }}
              onClick={handleRegisterCourse}
              style={{ width: 130, borderRadius: 5, marginRight: 10 }}
            />
          ) : course?.type === "waiting" && isInstructor ? (
            <IconButton
              text={"Delete"}
              textStyle={{ fontWeight: "500" }}
              onClick={handleOpenPopup}
              style={{
                width: 100,
                borderRadius: 5,
                backgroundColor: "#8B0000",
              }}
            />
          ) : null}
        </HorizontalLeftAlign>
      )}

      {openPopup && (
        <ModalComponent
          closeModal={handleClosePopup}
          openModal={openPopup}
          heading={`Delete Course`}
          yesBtn={deleteCourse}
          noBtn={handleClosePopup}
        >
          <HorizontalAlign>
            <RegLg>Are you sure want to delete</RegLg>
            <BoldLg style={{ marginLeft: 5, marginRight: 5 }}>
              {course?.title}
            </BoldLg>
            <RegLg>course?</RegLg>
          </HorizontalAlign>
        </ModalComponent>
      )}
    </Container>
  );
};

export default CourseDetails;
